import { VendorDataContractErrorList } from '../store/models/Project';

export const getLastErrorMessage = (errorList: VendorDataContractErrorList[] | null) => {
  if (!errorList) {
    return '';
  }

  const sortedErrors = [...errorList].sort((a, b) => {
    const parseDate = (dateStr: string) => {
      const [day, month, year] = dateStr.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    return parseDate(b.date) - parseDate(a.date);
  });

  const lastError = sortedErrors?.[0];

  return `[${lastError?.date || ''}]: ${lastError?.errorMessage || ''}`;
};
